import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RagChatToggleService {
  visible = signal(false);

  toggle(): void {
    this.visible.update((v) => !v);
  }

  open(): void {
    this.visible.set(true);
  }

  close(): void {
    this.visible.set(false);
  }
}
